import { isNumber } from 'lodash';

const OptionalValue: React.FC = ({ children }) => (
	<>{isNumber(children) ? children : children || '-'}</>
);

export default OptionalValue;
